import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../../../components-v2/Theme/theme';

const {
	colors,
	typography: { fontSizes },
	spacing,
	common,
} = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		width: 510,
		maxWidth: '90vw',
	},
	header: {
		borderBottom: common.border,
		padding: spacing.md,
		textAlign: 'center',
	},
	title: {
		color: colors.text.main,
		fontSize: fontSizes.lg,
		fontWeight: 600,
		margin: 0,
	},
	subtitle: {
		color: colors.text.light,
		fontSize: fontSizes.sm,
		margin: `${spacing.xs}px 0 0 0`,
	},
	unsavedNotice: {
		color: colors.text.light,
		fontSize: fontSizes.xs,
		marginTop: spacing.xs,
	},
	body: {
		flex: 1,
		overflow: 'auto',
		padding: spacing.md,
	},
	list: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
	},
	row: {
		alignItems: 'center',
		backgroundColor: colors.background.main,
		border: common.border,
		borderRadius: common.borderRadius,
		gap: spacing.md,
		display: 'flex',
		padding: spacing.md,
		transition: 'all 0.2s ease',
	},
	rowDragging: {
		boxShadow: '0 8px 16px rgba(0, 0, 0, 0.15)',
		opacity: 0.8,
		transform: 'rotate(2deg)',
	},
	dragHandle: {
		alignItems: 'center',
		cursor: 'grab',
		display: 'flex',
		justifyContent: 'center',
		':active': {
			cursor: 'grabbing',
		},
	},
	positionNumber: {
		alignItems: 'center',
		backgroundColor: colors.background.light,
		borderRadius: '50%',
		color: colors.text.main,
		display: 'flex',
		fontSize: fontSizes.sm,
		fontWeight: 600,
		height: 24,
		justifyContent: 'center',
		minWidth: 24,
	},
	content: {
		flex: 1,
		minWidth: 0,
	},
	footer: {
		borderTop: common.border,
		display: 'flex',
		gap: spacing.md,
		justifyContent: 'space-between',
		padding: spacing.md,
	},
});
